import { render } from "./payment_settings.vue?vue&type=template&id=989322bc"
import script from "./payment_settings.vue?vue&type=script&lang=js"
export * from "./payment_settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__